import React from 'react';
import { TIconProps } from 'pages/ExperienceCanvas/assets/types';

function UploadedStatusIcon({ fill = '#505A72', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      focusable={false}
    >
      <path
        d="M9.83333 4V2.5L12.8333 5.5H11.3333C10.28 5.5 9.83333 5.05333 9.83333 4ZM13.3333 6.5V12C13.3333 13.3333 12.6667 14 11.3333 14H5.33333C4 14 3.33333 13.3333 3.33333 12V4C3.33333 2.66667 4 2 5.33333 2H8.83333V4C8.83333 5.61333 9.72 6.5 11.3333 6.5H13.3333ZM10.3534 7.86866C10.158 7.67333 9.84133 7.67333 9.646 7.86866L7.77734 9.73734L7.01937 8.98C6.82403 8.78467 6.50734 8.78467 6.31201 8.98C6.11668 9.17533 6.11668 9.492 6.31201 9.68734L7.42334 10.7987C7.51734 10.8927 7.64403 10.9453 7.77669 10.9453C7.90936 10.9453 8.03671 10.8927 8.13005 10.7987L10.3521 8.57667C10.5487 8.38067 10.5487 8.064 10.3534 7.86866Z"
        fill={fill}
      />
    </svg>
  );
}

export default UploadedStatusIcon;
